"use client";

import React from "react";
import { Maximize2, X } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Dialog, DialogContent, DialogTrigger, DialogTitle, DialogDescription, DialogClose, DialogPortal, DialogOverlay } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const galleryItems = [{
  id: 1,
  title: "Offener Bereich",
  description: "Ein großzügiger Raum für kreativen Austausch und informelle Meetings in entspannter Atmosphäre.",
  image: "https://perfect-duck.10web.cloud/wp-content/uploads/2026/03/Loungebereich.jpg?v=lviskndd07",
  category: "Lounge"
}, {
  id: 2,
  title: "Konferenztisch",
  description: "Unser massiver Holztisch bietet Platz für bis zu 12 Personen und ist ideal für produktive Team-Sitzungen.",
  image: "https://perfect-duck.10web.cloud/wp-content/uploads/2026/03/Konferenzraum.jpg?v=uboulnwwcy",
  category: "Meeting"
}, {
  id: 3,
  title: "Schließfach",
  description: "Ausgestattet mit modernster Videokonferenz-Technik und High-Speed Glasfaser für reibungslose Calls.",
  image: "https://perfect-duck.10web.cloud/wp-content/uploads/2026/03/106-Bluvit_CoWorkingSpace_05052025_sandraschumann_0009-scaled.jpg?v=330cfcjx7dj",
  category: "Technik"
}, {
  id: 4,
  title: "Küche & Bar",
  description: "Voll ausgestattete Teeküche mit Premium-Kaffeemaschine und einer Auswahl an Erfrischungsgetränken.",
  image: "https://perfect-duck.10web.cloud/wp-content/uploads/2026/03/Kuche-scaled.jpg?v=380dj73hu1b",
  category: "Social"
}, {
  id: 5,
  title: "Fokus-Zone",
  description: "Schallisolierte Bereiche für konzentriertes Arbeiten oder vertrauliche Telefonate während des Tages.",
  image: "https://perfect-duck.10web.cloud/wp-content/uploads/2026/03/Schreibtischplatze.jpg?v=bikycnr9pfn",
  category: "Fokus"
}, {
  id: 6,
  title: "Eingangsbereich",
  description: "Ein repräsentatives Foyer, das Ihre Gäste mit modernem industriellem Charme willkommen heißt.",
  image: "https://perfect-duck.10web.cloud/wp-content/uploads/2026/03/40-Bluvit_CoWorkingSpace_05052025_sandraschumann_0078-scaled.jpg?v=t1msiug6hz",
  category: "Empfang"
}];
export default function Gallery() {
  return;
}